import React from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Box from '@mui/material/Box';
import { imageArray, AllowedFileTypes, getFileDetails } from '@askporter/utils';
import { fileIconMapping } from '../../utils';
interface ThumbnailPreviewProps {
  filePath: string;
  imgAlt?: string;
  fileType?: AllowedFileTypes;
}
/**
 * Displays a thumbnail image of the uploaded image or an icon
 * if the file type is not an image
 *
 * @param filePath - the file path of the uploaded file
 * @param imgAlt - (optional) the text to put in the 'alt' attribute when its an image
 *
 */
export const ThumbnailPreview: React.FC<React.PropsWithChildren<ThumbnailPreviewProps>> = ({
  filePath,
  fileType,
  imgAlt,
}: ThumbnailPreviewProps) => {
  const fileDetails = getFileDetails(filePath);
  let preview;
  const fileTypeToCheck = fileType || fileDetails.type;
  if (fileTypeToCheck && imageArray.includes(fileTypeToCheck)) {
    preview = (
      <img loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={filePath} alt={imgAlt} />
    );
  } else if (fileDetails.type) {
    preview = <>{fileIconMapping[fileDetails.type] || <InsertDriveFileIcon />}</>;
  } else {
    preview = <InsertDriveFileIcon />;
  }
  return (
    <Box
      data-testid="thumbnail-preview"
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#707070',
        bgcolor: 'background.default',
      }}
    >
      {preview}
    </Box>
  );
};
